export default {
      id: "icon-delete-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-delete",
      toString: function () {
        return this.url;
      }
    }